module.exports = __webpack_public_path__ + "img/unelmakone-karta-fi-mobile.9030e758.jpg";